export function trackDynamicUrlChange() {
    let url = window.location.pathname + window.location.search + window.location.hash;
    let ga = window["ga"] as any;
    if (ga) {
        ga("set", "page", window.location.pathname + window.location.search + window.location.hash);
        ga("send", "pageview");
    }
}
